import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      offers: 'offers/getContent',
      isPathActive: 'cart/isPathActive',
      isPathBeginningWithActive: 'cart/isPathBeginningWithActive',
      isOfferValid: 'offers/isOfferValid',
      isOfferVoid: 'offers/isOfferVoid',
      validDiscountOffers: 'offers/getValidDiscountOffers',
      validDiscountLoudOffers: 'offers/getValidDiscountLoudOffers',
      validDiscountLoudOffersValue: 'offers/getValidDiscountLoudOffersValue',
      validDiscountSilentOffers: 'offers/getValidDiscountSilentOffers',
      validDiscountSilentOffersValue: 'offers/getValidDiscountSilentOffersValue',
      validExternalOffers: 'offers/getValidExternalOffers',
      validInternalOffers: 'offers/getValidInternalOffers',
      validPercentageOffers: 'offers/getValidPercentageOffers',
      validPercentageOffersValue: 'offers/getValidPercentageOffersValue',
      validDiscountOffersValue: 'offers/getValidDiscountOffersValue',
      totalMobileBaseServicesPrice: 'fis/getTotalMobileBaseServicesPrice',
      totalNonFidelizedMobilBaseServicesPrice: 'fis/getTotalNonFidelizedMobilBaseServicesPrice',
      totalHiddenAdditionalServicesPrice: 'fis/getTotalHiddenAdditionalServicesPrice',
      activeItems: 'cart/getActiveItems',
      movelAdicionaisServicesPrice: 'cart/getMovelAdicionaisServicesPrice',
      simulationPackage: 'simulation/getPackage',
      activePackageConfig: 'packages/getActivePackageConfig'
    }),
    isOffer() {
      const offers = this.offers.filter(offer => offer.subject.target === this.path && this.isOfferValid(offer));
      return !!offers.length;
    },
    hasEligibleOffers() {
      const associatedOffers = this.offers.filter(offer => this.isPathRequiredInOffer(offer, this.path));
      const eligibleOffers = associatedOffers.filter(offer => this.isOfferEligible(offer, this.path));

      return eligibleOffers.length ? eligibleOffers.map(offer => offer.description) : false;
    },
    validOffers() {
      const offers = [];

      offers.push(...this.validInternalOffers);
      offers.push(...this.validPercentageOffers);

      // const discounts = this.validDiscountOffers.filter(i => !i.description.includes('15GB') && !i.description.includes('1GB'));
      // const discountsValue = this.validDiscountOffers.length ? discounts.map(i => i.subject.value).reduce((sum, x) => sum + x) : 0;

      const acumulatedOfferValue = this.totalNonFidelizedMobilBaseServicesPrice - this.totalMobileBaseServicesPrice - 2;

      if ((this.simulationPackage === 'movel.pospago' || this.simulationPackage === 'movel') && (acumulatedOfferValue > 0)) {
        offers.push({
          description: `Desconto de ${acumulatedOfferValue}€ durante período de fidelização`,
          subject: {
            category: 'mensality',
            type: 'discount'
          }
        });
      }

      if (offers.length) {
        offers.unshift(offers.splice(offers.findIndex(offer => offer.subject.category === 'galp'), 1)[0]);
      }

      /* external offers is here to the 15gb campaign appear on top of the list of offers */
      offers.unshift(...this.validDiscountOffers.filter(offer => !offer.subject.silentOnCart));
      offers.unshift(...this.validExternalOffers);

      return offers;
    },
    hasPeriodicOffer() {
      return !!this.validOffers.filter(offer => offer.subject.isPeriodic).length;
    }
  },
  methods: {
    isPathRequiredInOffer(_offer, _path) {
      const requiredItemsQuantity = _offer.relationships && _offer.relationships.required ? _offer.relationships.required.length : 0;

      if (requiredItemsQuantity) {
        return _offer.relationships.required.some((path) => {
          if (Array.isArray(path)) {
            return path.includes(_path);
          }

          return path === _path;
        });
      }

      return false;
    },
    isPathAnOffer(_path) {
      const offers = this.offers.filter(offer => offer.subject.target === _path && this.isOfferValid(offer));

      return !!offers.length;
    },
    isOfferVoidable(_offer, _path) {
      // If any void path is active, the offer resolves to void.
      const voidItemsQuantity = _offer.relationships && _offer.relationships.void ? _offer.relationships.void.length : 0;

      if (voidItemsQuantity) {
        return _offer.relationships.void.some((path) => {
          // In a void relationship, an array means that all paths within the array are required to be active in order to void the offer
          if (Array.isArray(path)) {
            return path.every((itemPath) => {
              // If an element of an array is itself an array, at least one of the paths must be active in order to resolve that element to true
              if (Array.isArray(itemPath)) {
                return path.some(subItemPath => this.isPathActive(subItemPath) || subItemPath === _path);
              }

              return this.isPathActive(itemPath) || itemPath === _path;
            });
          }

          return this.isPathActive(path) || path === _path;
        });
      }

      // If there are no defined relationships, the offer is not void.
      return false;
    },
    isOfferEligible(_offer, _path) {
      // Bail if offer is void.
      if (this.isOfferVoid(_offer) || this.isOfferVoidable(_offer, _path)) {
        return false;
      }

      // If offer is valid it's also considered eligible.
      if (this.isOfferValid(_offer)) {
        return true;
      }

      const requiredItemsQuantity = _offer.relationships && _offer.relationships.required ? _offer.relationships.required.length : 0;
      const missingRequiredItems = [];

      if (requiredItemsQuantity) {
        _offer.relationships.required.forEach((path) => {
          if (Array.isArray(path)) {
            if (!path.some(itemPath => this.isPathActive(itemPath))) {
              const missingPaths = path.filter(itemPath => !this.isPathActive(itemPath));

              if (missingPaths.length) {
                missingRequiredItems.push(missingPaths);
              }
            }
          } else if (!this.isPathActive(path)) {
            missingRequiredItems.push(path);
          }
        });
      }

      if (missingRequiredItems.length === 1) {
        const [missingRequiredItem] = missingRequiredItems;

        if (Array.isArray(missingRequiredItem)) {
          return missingRequiredItem.includes(_path);
        }

        return missingRequiredItem === _path;
      }

      return false;
    },
    getEligibleOffers(_path) {
      const associatedOffers = this.offers.filter(offer => this.isPathRequiredInOffer(offer, _path));
      const eligibleOffers = associatedOffers.filter(offer => this.isOfferEligible(offer, _path) && !offer.subject.silentOnChoice);

      const activeOffers = [];

      const displayOffers = eligibleOffers.filter((offer) => {
        if (offer.subject.family) {
          if (activeOffers.includes(offer.subject.family)) {
            return false;
          }

          activeOffers.push(offer.subject.family);
        }

        return true;
      });

      return displayOffers;
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/mixins/offers.js